import type { IconSvgObject } from './types';

const TurkishLiraIcon: IconSvgObject = [
  ["path", { d: "M10 3V20.052C10 20.6059 10.45 21.0616 10.998 20.9932C14.9453 20.5005 18 17.1233 18 13.0306", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 14L16 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 9L16 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TurkishLiraIcon;
